import React, { useState, useEffect } from "react";
import { Amplify } from "aws-amplify";
import { getCurrentUser } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

import "./App.css";
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import ArticlesPage from "./components/ArticlesPage";
import CodingTutorialsPage from "./components/CodingTutorialsPage";
import ContactPage from "./components/ContactPage";
import AdminPage from "./components/AdminPage";
import SignInPage from "./components/SignInPage";
import GamesPage from "./components/GamesPage";

// --- AMPLIFY CONFIGURATION ---
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: "us-east-1_hzQrQZUcR",
      userPoolClientId: "3pdbvku5bi4bo1c52ev6aonqqj",
    }
  }
};

Amplify.configure(awsConfig);

function App() {
  const [activeTab, setActiveTab] = useState("home");
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check current user on load
    checkUser();

    // Listen for auth events (signin, signout)
    const listener = (data) => {
      switch (data.payload.event) {
        case 'signedIn':
          checkUser();
          break;
        case 'signedOut':
          setUser(null);
          setActiveTab("home"); // Redirect to home on signout
          break;
        default:
          break;
      }
    };

    const hubListener = Hub.listen('auth', listener);

    return () => hubListener();
  }, []);

  const checkUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      setUser(null);
    }
  };

  const renderPage = () => {
    switch (activeTab) {
      case "home":
        return <HomePage setActiveTab={setActiveTab} />;
      case "about":
        return <AboutPage />;
      case "articles":
        return <ArticlesPage />;
      case "tutorials":
        return <CodingTutorialsPage />;
      case "games":
        return <GamesPage />;
      case "contact":
        return <ContactPage />;
      case "admin":
        return user ? <AdminPage /> : <SignInPage setActiveTab={setActiveTab} />;
      case "signin":
        return <SignInPage setActiveTab={setActiveTab} />;
      default:
        return <HomePage setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <div className="logo-container">
          <img
            src="/High-Resolution-Color-Logo-on-Transparent-Background.png"
            alt="Szafranski Computing Logo"
            className="logo"
          />
          <h1> Szafranski Computing </h1>
        </div>
        <nav>
          <ul>
            <li>
              <a
                href="#!"
                className={activeTab === "home" ? "active" : ""}
                onClick={() => setActiveTab("home")}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="#!"
                className={activeTab === "about" ? "active" : ""}
                onClick={() => setActiveTab("about")}
              >
                About Author
              </a>
            </li>
            <li>
              <a
                href="#!"
                className={activeTab === "articles" ? "active" : ""}
                onClick={() => setActiveTab("articles")}
              >
                Articles
              </a>
            </li>
            <li>
              <a
                href="#!"
                className={activeTab === "tutorials" ? "active" : ""}
                onClick={() => setActiveTab("tutorials")}
              >
                Coding Tutorials
              </a>
            </li>
            <li>
              <a
                href="#!"
                className={activeTab === "games" ? "active" : ""}
                onClick={() => setActiveTab("games")}
              >
                Games
              </a>
            </li>
            <li>
              <a
                href="#!"
                className={activeTab === "contact" ? "active" : ""}
                onClick={() => setActiveTab("contact")}
              >
                Contact
              </a>
            </li>
            {/* Show Admin tab only if user is signed in */}
            {user && (
              <li>
                <a
                  href="#!"
                  className={activeTab === "admin" ? "active" : ""}
                  onClick={() => setActiveTab("admin")}
                >
                  Admin
                </a>
              </li>
            )}
            {/* Sign In / Profile Tab */}
            <li>
              <a
                href="#!"
                className={activeTab === "signin" ? "active" : ""}
                onClick={() => setActiveTab("signin")}
              >
                {user ? "Profile" : "Sign In"}
              </a>
            </li>
          </ul>
        </nav>
      </header>
      <main> {renderPage()} </main>
    </div>
  );
}

export default App;
